import { mapMutations } from "vuex";

/**
 * Add and edit appointment home mixin
 */
export const addEditAppointmentHomeMixin = {
  data() {
    return {
      addOption: "" // Which add option is selected
    };
  },
  methods: {
    ...mapMutations({
      setAppointmentTypeClear: "setAppointmentTypeClear" // Weather the current add appointment details should be deleted or not
    }),
    ...mapMutations("addNew", {
      setFirstName: "setFirstName", // Sets the first name
      setLastName: "setLastName" // Sets the last name
    }),
    /**
     * When add option client/person/event/group option is selected
     */
    addOptionSelected({ name, addOption }) {
      // Step 1: Show the option
      this.addOption = addOption;
      let timeout = 0;

      // Step 2: Check if we are adding a person
      if (this.addOption !== "person" && this.addOption !== "client") {
        return this.setFirstName(name.trim());
      }

      // Step 3: Go to the client page when add appointment is selected
      if (this.addOption === "client") {
        this.setAppointmentTypeClear(false);
        this.$router.push("/add_client");
        timeout = 200;
      }

      // Step 4: When trying to add a person, split the name from space
      const splitName = name.split(" ");

      // Step 5: Check if the user has entered two parts of the name
      if (splitName.length === 1) {
        return setTimeout(() => {
          this.setFirstName(name.trim());
        }, timeout);
      }

      // Step 6: Set the first name and last name
      setTimeout(() => {
        this.setFirstName(splitName[0]);
        this.setLastName(splitName.splice(1).join(" "));
      }, timeout);
    },
    /**
     * Hides the add option
     */
    hideAddOption() {
      this.addOption = "";
    }
  }
};
